import Project from "../../../model2/project/project";
import ProjectSession from "../../../model2/project/project-session";


// This is deprecated
// use either ACLProject.XXX
// or ProjectModel.acl.XXX - recommended


module.exports = {

    canSaveProjectSettings(projectId:ID) {
        return gd.projectViews.currentView.access === 'private' || gd.ac.check.project.fullAccess(projectId)
    },

    canCreateSubproject(projectId:ID) {
        let res = false;
        if (projectId) {

            const project = gd.session.projects.get(projectId);

            if (!project) return false;

            const projectAccess = project.access;
            // const companyId = project.companyId;

            // if (!gd.session.companies.get(companyId)) return false;

            res = projectAccess >= gd.const.project.access.STANDARD;
        }

        return res;
    },

    canMoveIntoRoot(projectId:ID) {
        let res = false;
        if (projectId) {

            const project = gd.session.projects.get(projectId);

            if (!project) return false;

            // const companyId = project.companyId;
            // if (!gd.session.companies.get(companyId)) return false;

            let organizationRole = gd.session.companies.get(gd.companyId).role;

            res = organizationRole >= gd.const.companyRole.MANAGER;
        }

        return res;
    },

    canDeleteDuplicate(projectId:ID, project?:Project) {
        let res = false
        if (projectId) {
            let projectAccess = 0, sProject
            try {
                sProject = project ? project : gd.session.projects.get(projectId)!
                projectAccess = sProject.access
            } catch(e) {
                console.error("Check rules project canDeleteDuplicate error:", projectId, sProject)
            }

            res = projectAccess >= gd.const.project.access.FULL
        }

        return res
    },

    canReadOnly(projectId:ID, project?:Project) {
        let res = false;
        if (projectId) {
            let projectAccess = 0, sProject;
            try {
                sProject = project ? project : gd.session.projects.get(projectId)!
                projectAccess = sProject.access;
            } catch(e) {
                console.error("Check rules canReadOnly error:", projectId, sProject);
            }

            // res = [gd.const.project.access.STANDARD].includes(projectAccess);
            res = [gd.const.project.access.READ_ONLY, gd.const.project.access.CLIENT].includes(projectAccess);
        }

        return res;
    },

    canReadAndComment(projectId:ID, project?:Project) {

        let res = false;
        if (projectId) {
            let projectAccess = 0, sProject;
            try {
                sProject = project ? project : gd.session.projects.get(projectId);
                // @ts-ignore
                projectAccess = sProject.access;
            } catch(e) {
                console.error("Check rules canReadAndComment error:", projectId, sProject);
            }

            res = projectAccess >= gd.const.project.access.CLIENT;
        }

        return res;
    },

    limitedAccess(projectId:ID, project:Project) {

        let res = false
        if (projectId) {

            let projectAccess = 0, sProject
            try {
                sProject = project ? project : gd.session.projects.get(projectId)!
                projectAccess = sProject.access
            } catch(e) {
                console.error("Check rules limitedAccess error:", projectId, sProject)
            }

            res = projectAccess >= gd.const.project.access.LIMITED
        }

        return res;
    },

    standardAccess(projectId:ID, project?:Project) {

        let res = false;
        if (projectId) {

            let projectAccess = 0
            let sProject    : ProjectSession

            try {
                sProject = project ? project : gd.session.projects.get(projectId)!
                projectAccess = sProject.access
            } catch(e) {
                // @ts-ignore
                console.error("Check rules standardAccess error:", projectId, sProject)
            }

            // template fix - not sure if good one but I think it's ok as undifined
            // @ts-ignore
            if (sProject.access === undefined && sProject.isTemplate) {
                return true
            }

            res = projectAccess >= gd.const.project.access.STANDARD
        }

        return res;
    },

    fullAccess(projectId:ID, project?:Project) {
        let res = false;
        if (projectId) {

            let projectAccess = 0, sProject

            try {
                sProject = project ? project : gd.session.projects.get(projectId)
                if (sProject) projectAccess = sProject.access
            } catch(e) {
                console.warn("Check rules fullAccess error:", projectId, sProject)
            }

            // template fix - not sure if good one but I think it's ok as undifined
            if (sProject?.access === undefined && sProject?.isTemplate && gd.company.role === gd.const.companyRole.MANAGER) {
                return true
            }

            res = projectAccess >= gd.const.project.access.FULL
        }

        return res;
    }
};
